import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
// Importamos HashLink
import { HashLink } from 'react-router-hash-link'; 
import logoReto from "../images/logoReto.png";
import Equipacion from '../components/Equipacion';
import Temporizador from '../components/Temporizador';
import fondoCastillo from "../images/Gemini_Generated_Image_udjcwuudjcwuudjc.png";
import letrasDisney from "../images/pngegg.png";
import irARutas from "../images/irARutas.jpg";
import Colaboradores from './Colaboradores';
import '../css/HomeTest.css';
import Motivos from './Motivos';
import RecaudacionHistorica from '../components/RecaudacionHistorica';
import SeccionVideo from '../components/SeccionVideo';
import logoPequeñoDeseo from "../images/deseo.jpeg"; 
import FotosReto from '../components/fotosReto';


const HomeTest = () => {
  const navigate = useNavigate();

  // 1. Modificamos el estado inicial: si ya se mostró en la sesión, empezamos en false
  const [isFetching, setIsFetching] = useState(() => {
    const yaCargado = sessionStorage.getItem('homeLoaderMostrado');
    return yaCargado ? false : true;
  });

  useEffect(() => {
    // 2. Si ya se había marcado como cargado antes, no hacemos el timer
    if (!isFetching) return;

    const timer = setTimeout(() => {
      setIsFetching(false);
      // 3. Guardamos en la sesión que ya se mostró para la próxima vez que vuelvan
      sessionStorage.setItem('homeLoaderMostrado', 'true');
    }, 2000);

    return () => clearTimeout(timer);
  }, [isFetching]); // Añadimos isFetching como dependencia por seguridad

  if (isFetching) {
    return (
      <div className="full-page-loader">
        <div className="loader-content">
          <img src={logoReto} alt="Cargando..." className="loader-logo-pulse" />
          <div className="loading-bar-container">
            <div className="loading-bar-fill"></div>
          </div>
          <p>Preparando el reto...</p>
        </div>
      </div>
    );
  }

  return (
    <main className="home-main-container fade-in-page">

      {/* SECCIÓN 1: HERO */}
      <section className="hero-full-section" style={{ backgroundImage: `url(${fondoCastillo})` }}>
        <div className="page">
          <div className="hero-animation-container">
            <div className="top-row-centered">
              <img src={logoReto} alt="Logo El Reto de Carmen" />
            </div>  

              
                {/* * ÁREA DE INFO DEL RETO * */}

            {/* <div className="anim-box disney-box">
              <div className="disney-card">
                <div className="disney-header-container">
                  <img src={letrasDisney} alt="Disneyland Paris" className="disney-logo-img" />
                  <span className="disney-subtitle-location">→ Higueruela</span>
                </div>
                <h3 className="disney-transport-tag">EN BICICLETA</h3>
                <div className="disney-stats">
                  <span>12, 13 y 14 de junio</span> <span className="dot">•</span> <span>1450 KM</span>
                </div>
                <p className="disney-nonstop">NON STOP</p>
                <button className="hash-button btn-hero-main" onClick={() => navigate('/el-reto')}>
                  CONOCE EL RETO
                </button>
              </div>
            </div> */}

                {/* * FIN ÁREA DE INFO DEL RETO * */}
          </div>

          <FotosReto/>
          



          <div className="fade-in-delayed">
            <Temporizador />
          </div>
      <RecaudacionHistorica/>

      <div>
        <SeccionVideo/>
      </div>

          <div className="page">
            <div className="container-links-full">
              <div className="links-column">
                <Link to="/conoce-a-carmen">Quién es Carmen</Link>
                
                {/* HashLink a Motivos */}
                <HashLink smooth to="/#seccion-motivos">Razones para pedalear</HashLink>
                
                <Link to="/colaboradores">Colaboradores</Link>
                <Link to="/rutas-bicicletas">Rutas en Bicicleta</Link>
              </div>
              <div className="links-column">
                <Link to="/el-reto">Reto Actual</Link>
                <Link to="/colabora">Cómo colaborar</Link>
                
                {/* HashLink a Motivos (Objetivo Solidario) */}
                <HashLink smooth to="/#seccion-motivos">Objetivo Solidario</HashLink>
                
                <Link to="/sigue-el-reto">Sigue el reto</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 2: APOYO/MOTOR */}
      <section className="home-support-section">
        <div className="page">
          <div className="support-container">
            <div className="support-info">
              <h2 className="support-title">TU APOYO ES NUESTRO <span className="pink-text">MOTOR</span></h2>
              <p className="support-description">
                Cada kilómetro que pedaleamos tiene un propósito. Tu colaboración se transforma directamente en apoyo para quienes más lo necesitan.
              </p>
              <blockquote className="support-wish">
                "Que ninguna montaña sea tan alta como nuestras ganas de ayudar."
              </blockquote>
               {/* OPCIÓN 1: BIZUM */}
          <div className="colabora-card bizum-card">
            <div className="card-icon">📱</div>
            <div className="card-info">
              <h3>Dona con Bizum</h3>
              <div className="bizum-details">
                <span className="biz_label">CÓDIGO ONG:</span>
                <span className="biz_code">33605</span>
              </div>
              <p className="concept-highlight">Concepto: <strong>El Reto de Carmen</strong></p>
            </div>
          </div>

          {/* OPCIÓN 2: TRANSFERENCIA (CON LOGO DE FUNDACIÓN) */}
          <div className="colabora-card fpd-card">
            <div className="card-icon"><img src={logoPequeñoDeseo} alt="Fundación Pequeño Deseo" className="inline-fpd-logo" /></div>
            <div className="card-info">
              <div className="title-with-logo">
                <h3>Fundación Pequeño Deseo</h3>
              </div>
              <p>Transferencia directa la cuenta oficial de la <strong>Fundación Pequeño Deseo</strong></p>
              <p className="iban-display">ES27 2100 0835 1802 0104 4861</p>
              <span className="helper-tag">Indica en concepto  <strong>"El Reto de Carmen"</strong> al realizarla</span>
            </div>
          </div>
              <div className="support-footer-row">
                <button className="btn-colabora-main" onClick={() => navigate('/colabora')}>
                  COLABORA CON NOSOTROS
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 3: RUTAS */}
      <section className="routes-preview-section">
        <Link to="/rutas-bicicletas" className="section-clickable-overlay">
          <div className="page">
            <div className="routes-container">
              <div className="routes-image-box">
                <img src={irARutas} alt="Rutas en bicicleta" className="route-img-preview" />
                <div className="route-overlay-tag">PRÓXIMA ETAPA</div>
              </div>
              <div className="routes-text-box">
                <h2 className="section-title-light">RUTAS EN <span className="highlight-text">BICICLETA</span></h2>
                <p className="section-description">
                  Explora los senderos y carreteras que forman parte de este desafío.
                </p>
                <button className="hash-button btn-outline">VER TODAS LAS RUTAS</button>
              </div>
            </div>
          </div>
        </Link>
      </section>

      {/* ANCLA PARA HASHLINK */}
      <div id="seccion-motivos">
        <Motivos/>
      </div>

      {/* SECCIÓN 4: COLABORADORES */}
      <section className="home-partners-full-block">
        <div className="page">
          <div className="partners-upper-flex">
            <div className="partners-text-intro">
              <h2 className="section-title">NUESTROS <span className="pink-text">ALIADOS</span></h2>
              <p>
                Este reto no sería posible sin las empresas y entidades que pedalean a nuestro lado.
              </p>
            </div>
            <div className="partners-equipacion-box">
              <Equipacion />
            </div>
          </div>

          <div className="partners-list-wrapper">
            <Colaboradores />
          </div>
        </div>
      </section>

    </main>
  );
};

export default HomeTest;